"use client";

import { useCallback, useState } from "react";
import {
  buildFilterKey,
  filterKeysEqual,
  LISTING_BROWSE_PAGE_SIZE as PAGE_SIZE,
  type FilterKey,
  type UseListingBrowseProductsArgs,
} from "./listing-browse-query";
import {
  usePrimaryListingBrowseData,
  useSmartFallbackData,
} from "./use-listing-browse-data";
import { resolveListingBrowseViewState } from "./listing-browse-view-state";

export function useListingBrowseProducts(args: UseListingBrowseProductsArgs) {
  const [page, setPage] = useState(1);
  const [previousFilterKey, setPreviousFilterKey] = useState<FilterKey>(() =>
    buildFilterKey(args),
  );
  const currentFilterKey = buildFilterKey(args);
  if (!filterKeysEqual(previousFilterKey, currentFilterKey)) {
    setPreviousFilterKey(currentFilterKey);
    setPage(1);
  }

  const primary = usePrimaryListingBrowseData(args, page, setPage);
  const smartFallback = useSmartFallbackData(args, page, primary);
  const viewState = resolveListingBrowseViewState(
    args,
    page,
    primary,
    smartFallback,
  );
  const changePage = useCallback((nextPage: number) => setPage(nextPage), []);

  return {
    ...viewState,
    page,
    setPage: changePage,
    pageSize: PAGE_SIZE,
  };
}
